<header class="header-toolbar" fxLayout="row" fxLayoutAlign="center">
  <dx-toolbar>
    <dxi-item
      *ngIf="menuToggleEnabled"
      location="before"
      widget="dxButton"
      cssClass="menu-button"
      [options]="{
                icon: 'menu',
                stylingMode: 'text',
                onClick: toggleMenu
            }"
    >
    </dxi-item>
    <dxi-item location="before" *ngIf="screen.isDesktop()" cssClass="header-title">
      <img class="desktop-logo" [src]="appInfo.logo"/>
    </dxi-item>
    <dxi-item
      location="before"
      *ngIf="screen.isDesktop()"
      cssClass="header-title"
      [style.height]="screen.isDesktop() ? '54px' : 'auto'"
    >
      <app-top-navigation-menu></app-top-navigation-menu>
    </dxi-item>
    <dxi-item location="after" locateInMenu="auto" menuItemTemplate="menuItem">
      <div *dxTemplate="let data of 'item'">
        <dx-button class="user-button authorization" width="fit-content" height="100%" stylingMode="text">
          <div *dxTemplate="let data of 'content'">
            <app-user-panel [menuItems]="userMenuItems" menuMode="context"></app-user-panel>
          </div>
        </dx-button>
      </div>
    </dxi-item>
    <div *dxTemplate="let data of 'menuItem'">
      <app-user-panel [menuItems]="userMenuItems" menuMode="list"></app-user-panel>
    </div>
  </dx-toolbar>
</header>

<app-user-profile
  [popupVisible]="userProfilePopup"
  (closeEvent)="userProfilePopup = false">
</app-user-profile>

